import { FunctionComponent, useMemo } from 'react';

import { CssBaseline, GlobalStyles } from '@mui/material';

import { Provider } from 'react-redux';
import { store } from '@/store';
import { Toaster } from 'sonner';
import { isDevelopment } from '@/constants';
import { StagingBanner } from '@starjack/layout';
import { StarjackLocalizationProvider } from '@/components/Providers/StarjackLocalizationProvider';
import { I18nextProvider } from 'react-i18next';
import { initI18nNext } from '@/i18n';
import { AppRoutes } from './routes';

import 'simplebar-react/dist/simplebar.min.css';

const App: FunctionComponent = () => {
    const i18n = useMemo(() => initI18nNext(), []);

    return (
        <I18nextProvider i18n={i18n}>
            <Provider store={store}>
                <StarjackLocalizationProvider>
                    <CssBaseline />
                    <GlobalStyles
                        styles={{
                            '#produktly-portal-root span': {
                                zIndex: 1150,
                            },
                        }}
                    />
                    {isDevelopment && <StagingBanner />}

                    <AppRoutes />
                    <Toaster richColors position='bottom-right' />
                </StarjackLocalizationProvider>
            </Provider>
        </I18nextProvider>
    );
};

export default App;
